declare namespace $ {

	type $mol_string_button__value_bog_wikilive_table_view_1 = $mol_type_enforce<
		ReturnType< $bog_wikilive_table_view['table_title'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_string_button__hint_bog_wikilive_table_view_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $mol_button_minor__title_bog_wikilive_table_view_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_wikilive_table_view_4 = $mol_type_enforce<
		ReturnType< $bog_wikilive_table_view['col_add_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_wikilive_table_view_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_wikilive_table_view_6 = $mol_type_enforce<
		ReturnType< $bog_wikilive_table_view['row_add_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_bog_wikilive_table_view_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_wikilive_table_view_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_grid__col_ids_bog_wikilive_table_view_9 = $mol_type_enforce<
		ReturnType< $bog_wikilive_table_view['col_ids'] >
		,
		ReturnType< $mol_grid['col_ids'] >
	>
	type $mol_grid__row_ids_bog_wikilive_table_view_10 = $mol_type_enforce<
		ReturnType< $bog_wikilive_table_view['row_ids'] >
		,
		ReturnType< $mol_grid['row_ids'] >
	>
	type $mol_grid__head_cells_bog_wikilive_table_view_11 = $mol_type_enforce<
		ReturnType< $bog_wikilive_table_view['head_cells'] >
		,
		ReturnType< $mol_grid['head_cells'] >
	>
	type $mol_grid__cells_bog_wikilive_table_view_12 = $mol_type_enforce<
		ReturnType< $bog_wikilive_table_view['cells'] >
		,
		ReturnType< $mol_grid['cells'] >
	>
	type $mol_view__dom_name_bog_wikilive_table_view_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_view['dom_name'] >
	>
	type $mol_view__sub_bog_wikilive_table_view_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__value_bog_wikilive_table_view_15 = $mol_type_enforce<
		ReturnType< $bog_wikilive_table_view['cell_val'] >
		,
		ReturnType< $mol_string['value'] >
	>
	export class $bog_wikilive_table_view extends $mol_view {
		table_title( next?: string ): string
		Title_edit( ): $mol_string_button
		col_add_click( next?: any ): any
		Add_col( ): $mol_button_minor
		row_add_click( next?: any ): any
		Add_row( ): $mol_button_minor
		Tools( ): $mol_view
		Header( ): $mol_view
		col_ids( ): readonly(any)[]
		row_ids( ): readonly(any)[]
		head_cells( ): readonly(any)[]
		cells( id: any): readonly(any)[]
		Grid( ): $mol_grid
		col_title( id: any): string
		cell_val( id: any, next?: string ): string
		table( ): $bog_wikilive_table
		sub( ): readonly(any)[]
		Col_head( id: any): $mol_view
		Cell( id: any): $mol_string
	}
	
}

//# sourceMappingURL=table.view.tree.d.ts.map